import { useEffect, useState } from "react";
import AvatarMy from "./AvatarMy";
import { useSidebar } from "../context/ClinicContext";
import { jwtDecode } from "jwt-decode";
import { ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import {
  FaRegHospital,
  FaRegUser,
  FaUserEdit,
  FaUserInjured,
  FaUserMd,
} from "react-icons/fa";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import HeaderSearch from "../../prescription/components/HeaderSearch";
import axios from "axios";
import TopSearchHeader from "../../prescription/components/TopSearch";

const Header = (props) => {
  const [firstName, setFirstName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const [patient, setPatient] = useState(""); // This will hold the selected patient
  const [patientDetails, setPatientDetails] = useState({
    name: "",
    age: "",
    gender: "",
    phone: "",
    // Add other fields as needed
  });

  useEffect(() => {
    const fetchDoctorId = async () => {
      const token = localStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      console.log(decodedToken);
      setFirstName(decodedToken.first_name);
    };

    fetchDoctorId();
  }, []);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleClose();
  };

  const logOut = () => {
    localStorage.removeItem("token");
    navigate(0);
  };

  const location = useLocation();
  const settingSideBarShow =
    location.pathname === "/clinic/setting" ||
    location.pathname === "/clinic/UserProfile" ||
    location.pathname === "/clinic/service" ||
    location.pathname === "/clinic/ClinicProfile" ||
    location.pathname === "/clinic/EMRSettings";

  return (
    <header
      className={`header shadow-md shadow-gray-200 bg-gradient-to-r bg-white border-l border-gray-100 fixed  z-30
    w-full ${settingSideBarShow ? "md:w-[calc(100%-128px)]" : "md:w-[calc(100%-64px)]"}
    `}
    >
      <div className="header-wrapper h-[70px] flex justify-between items-center pl-14 md:pl-4 pr-4 xl:px-5">
        <div className="header-action header-action-start"></div>

        <TopSearchHeader
          patient={patient}
          setPatient={setPatient}
          patientDetails={patientDetails}
          setPatientDetails={setPatientDetails}
        />

        <div className="header-action header-action-end inline-flex items-center gap-x-5">
          <div className="inline-flex items-center">
            <div className="m-1/4 cursor-pointer rounded-full p-2 text-[#2E37A4] font-semibold text-lg">
              {firstName}
            </div>
            <div
              className="m-1/4 cursor-pointer rounded-full p-2"
              onClick={handleProfileClick}
            >
              <AvatarMy alt={firstName} src="/broken-image.jpg" />
            </div>

            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
            >
              <MenuItem onClick={() => handleNavigate("/clinic/ClinicProfile")}>
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                Settings
              </MenuItem>
              <MenuItem onClick={() => logOut()}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>

          <div className="inline-flex items-center hidden">
            <button className="w-10 h-10 inline-flex justify-center items-center rounded-full hover:bg-gray-100 cursor-pointer">
              <img src="images/icons/setting-icon-01.svg" alt="Settings" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
